import Icon from 'veui/components/Icon'
import { IconAlignLeft } from 'dls-icons-vue'

Icon.register('align-left', IconAlignLeft)
